import styled from 'styled-components';
import Section from '../../Section';
import CompartmentDetailGrid from '../CompartmentDetailGrid';

const ItemWrapper = styled.div`

  &:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.colors.bg_gray};
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`;

function CompartmentList({data, onDelete}) {

  if(data?.length === 0) {
    return null;
  }

  return (
    <Section title="Compartments" isCollapsible={false}>
      {
        data?.map((item, idx) => (

          <ItemWrapper key={item.properties.id}>
            <CompartmentDetailGrid data={item.properties} onDelete={() => onDelete({item, idx})}  />
          </ItemWrapper>
        ))
      }
    </Section>
  );
}

export default CompartmentList;